import { useTranslation } from "@opendash/i18n";
import { Tag } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { StepFieldType } from "..";

export const StepMetaTag = observer(
  (props: { stepfield: StepFieldType; getTagValue }) => {
    const t = useTranslation();
    const [tagValue, setTagValue] = useState<string>("");

    useEffect(() => {
      const fetch = async () => {
        await Promise.all(props.getTagValue(props.stepfield)).then((value) => {
          setTagValue(value.join(", "));
        });
      };

      fetch();
    }, [props.stepfield]);

    return (
      <Tag>
        {t("maintenance:stepmetafields.display.value.label", {
          label: props.stepfield.metafield.label,
          value: tagValue,
        })}
      </Tag>
    );
  }
);
